import React from 'react';
import {
  headerStyle, breadcrumb as breadcrumbStyle, titleStyle, subtitleStyle,
  primaryBtn, secondaryBtn,
} from '../styles/theme';

interface PageHeaderProps {
  breadcrumb: string;
  title: string;
  subtitle: string;
  syncLabel?: string;
  revalidating?: boolean;
  loading?: boolean;
  lastSyncedAt?: number | null;
  onRefresh?: () => void;
  onExport?: () => void;
  extraButtons?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  breadcrumb: bc, title, subtitle,
  syncLabel, revalidating, loading, lastSyncedAt,
  onRefresh, onExport, extraButtons,
}) => (
  <div style={headerStyle}>
    <div>
      <div style={breadcrumbStyle}>{bc}</div>
      <h1 style={titleStyle}>{title}</h1>
      <p style={subtitleStyle}>{subtitle}</p>
    </div>
    <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
      {lastSyncedAt && !loading && (
        <span style={{
          fontSize: 11,
          color: revalidating ? '#f59e0b' : '#94a3b8',
          display: 'flex', alignItems: 'center', gap: 4,
        }}>
          {revalidating ? ' Syncing…' : `✓ Synced ${syncLabel}`}
        </span>
      )}
      {extraButtons}
      {onExport && <button style={secondaryBtn} onClick={onExport}> Export CSV</button>}
      {onRefresh && (
        <button style={primaryBtn} onClick={onRefresh}>↻ Refresh</button>
      )}
    </div>
  </div>
);

export default PageHeader;
